import { selfAxios } from "../../../../../axios/selfAxios.js";
async function opPostQueryOrderMappingProductRuleList(params) {
  const res = await selfAxios.post(`/designapi/design/retailOrder/queryOrderMappingProductRuleList`, params, {
    _cache: true
  });
  return res.data;
}
export { opPostQueryOrderMappingProductRuleList };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designapi/design/retailOrder/queryOrderMappingProductRuleList/post.js